import React from "react";
import ImageGallery from 'react-image-gallery';


export interface IDesktopGalleryProps {
  children?: any;
  galleryOverrides?: any;
  images: { original: string, thumbnail: string }[],
}

const DesktopGallery = (props: IDesktopGalleryProps) => (
  <ImageGallery
    showFullscreenButton={false}
    useBrowserFullscreen={false}
    showPlayButton={false}
    slideInterval={0}
    slideDuration={0}
    lazyLoad={true}
    showIndex={false}
    showThumbnails={false}
    showBullets={true}
    showNav={false}
    disableThumbnailScroll={true}
    disableKeyDown={true}
    items={props.images}
    renderOverlay={() => props.children}
    {...props.galleryOverrides}
  />);

DesktopGallery.defaultProps = {};

export default DesktopGallery;
